/* Staey Size Guide 2.0 — anbefaling + fit-bars
   Regel: mindste størrelse hvor intet indtastet mål overstiger størrelsens max.
   Mål under min er ok, men giver "rummelig" + evt. advarsel over tolerance. */
(function (global) {
  'use strict';

  var TOLERANCE = { back: 3, chest: 5, neck: 3 };
  var STORAGE_KEY = 'staey_dog_measurements';

  function normKey(name) {
    var n = String(name || '').toLowerCase().trim();
    if (/back|ryg|rück|rug|dos|rygg/.test(n)) return 'back';
    if (/breast|chest|bryst|brust|borst|poitrine|bröst/.test(n)) return 'chest';
    if (/neck|hals|nek|cou/.test(n)) return 'neck';
    return n.replace(/[^a-z0-9]/g, '') || 'm';
  }

  /* Parser metaobjekt-feltet `mal`:
     "Back: 25-29, 30-34\nSize: XXS, XS\n###\nBreast: ..." */
  function parseMal(text) {
    var blocks = String(text || '').split('###');
    var measurements = [];
    var order = [];
    blocks.forEach(function (b) {
      /* Tåler både linjeskift og oversættelser uden linjeskift:
         "Ryg: 25-29, 30-34 Størrelse: XXS, XS" */
      var flat = b.replace(/\s+/g, ' ').trim();
      var m = flat.match(/^([^:]+):\s*([\d\s.,\-–]+?)\s*([^\d\s:,.\-–][^:]*):\s*(.+)$/);
      if (!m) return;
      var name = m[1].trim();
      var ranges = m[2].split(',').map(function (r) {
        var p = r.trim().split(/[-–]/);
        return { min: parseFloat(p[0]), max: parseFloat(p[1]) };
      }).filter(function (r) { return !isNaN(r.min); });
      var sizes = m[4].split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      if (ranges.length !== sizes.length) return;
      var bySize = {};
      sizes.forEach(function (sz, i) {
        if (!isNaN(ranges[i].min) && !isNaN(ranges[i].max)) bySize[sz] = ranges[i];
        if (order.indexOf(sz) === -1) order.push(sz);
      });
      measurements.push({ key: normKey(name), name: name, bySize: bySize });
    });
    return { measurements: measurements, sizes: order };
  }

  function fitValue(v, r) { return r.max === r.min ? 0.5 : (v - r.min) / (r.max - r.min); }

  function evaluateSize(chart, size, input) {
    var res = { size: size, status: 'ok', fits: [], warnings: [] };
    chart.measurements.forEach(function (m) {
      var v = input[m.key];
      if (v == null || isNaN(v)) return;
      var r = m.bySize[size];
      if (!r) { res.status = 'no'; return; }
      var tol = TOLERANCE[m.key] != null ? TOLERANCE[m.key] : 3;
      var f = fitValue(v, r);
      var level;
      if (v > r.max) { level = 'too_tight'; res.status = 'no'; }
      else if (v < r.min) { level = 'roomy'; }
      else if (f < 0.33) level = 'relaxed';
      else if (f < 0.66) level = 'perfect';
      else level = 'snug';
      var tooLoose = v < r.min - tol;
      if (tooLoose) {
        res.warnings.push(m.key);
        if (res.status === 'ok') res.status = 'warn';
      }
      res.fits.push({ key: m.key, name: m.name, value: v, min: r.min, max: r.max, fit: f, level: level, tooLoose: tooLoose, tol: tol });
    });
    return res;
  }

  function recommend(chart, input, opts) {
    opts = opts || {};
    var entered = chart.measurements.filter(function (m) { return input[m.key] != null && !isNaN(input[m.key]); });
    var missing = chart.measurements.filter(function (m) { return entered.indexOf(m) === -1; }).map(function (m) { return m.key; });
    var perSize = chart.sizes.map(function (s) { return evaluateSize(chart, s, input); });
    if (!entered.length) return { size: null, perSize: perSize, missing: missing, empty: true };
    var idx = -1;
    for (var i = 0; i < perSize.length; i++) { if (perSize[i].status !== 'no') { idx = i; break; } }
    if (idx >= 0 && opts.tieBreak === 'largest' && perSize[idx + 1] && perSize[idx + 1].status === 'ok') {
      /* "vælg størst": gå én op hvis næste størrelse også passer uden advarsel */
      idx = idx + 1;
    }
    return { size: idx >= 0 ? perSize[idx].size : null, index: idx, perSize: perSize, missing: missing, empty: false };
  }

  /* markørposition 0–100 (venstre = løs, højre = tæt) */
  function markerPos(fit) {
    var p;
    if (fit.value < fit.min) {
      var below = (fit.min - fit.value) / Math.max(fit.tol * 2, 1);
      p = 12 - 12 * Math.min(below, 1);
    } else {
      p = 12 + 82 * Math.min(fit.fit, 1);
    }
    return Math.max(2, Math.min(98, p));
  }

  var api = { parseMal: parseMal, recommend: recommend, evaluateSize: evaluateSize, markerPos: markerPos, normKey: normKey };
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; return; }
  if (global.StaeySizeGuide) return; /* allerede indlæst */
  global.StaeySizeGuide = api;

  /* ---------------- UI ---------------- */
  function fmt(str, vars) { return String(str || '').replace(/\{(\w+)\}/g, function (_, k) { return vars[k] != null ? vars[k] : ''; }); }
  function loadSaved() { try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}') || {}; } catch (e) { return {}; } }
  function save(obj) { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(obj)); } catch (e) {} }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* Måleillustration (Staey-stil). Markører vises kun for de mål produktet har. */
  var DOG_SVG =
    '<svg class="sg2-dog" viewBox="0 0 400 260" role="img" aria-hidden="true" focusable="false">' +
    '<path d="M180 160 C182 186 184 206 186 226 L198 226 C196 206 195 184 196 162 Z" fill="#C9CDBF"/>' +
    '<path d="M284 152 C292 178 298 204 302 226 L314 226 C310 200 306 176 302 154 Z" fill="#C9CDBF"/>' +
    '<path fill="#A7AE9C" d="M324 120 C338 112 350 96 354 72 C356 64 363 65 362 74 C360 98 346 120 328 134 Z"/>' +
    '<path fill="#A7AE9C" d="M58 74 C60 66 70 60 80 58 C88 48 100 44 110 46 C122 48 128 58 130 70 C134 84 142 96 156 102 C200 106 260 104 300 104 C316 104 326 114 328 128 C330 142 326 152 320 160 C322 180 326 205 330 224 C332 230 326 233 316 232 C312 231 310 228 310 224 C306 204 300 186 292 168 C290 164 286 162 280 162 C244 168 204 168 180 164 C174 166 172 172 172 180 C172 198 172 212 170 224 C170 230 164 233 154 232 C150 231 149 228 150 224 C152 204 152 184 148 166 C136 158 126 144 120 128 C114 112 104 100 94 94 C84 90 72 88 64 86 C58 84 56 80 58 74 Z"/>' +
    '<path fill="#8E9683" d="M106 50 C116 50 122 58 122 70 C122 84 118 94 112 96 C106 92 102 80 102 68 C102 58 103 52 106 50 Z"/>' +
    '<circle cx="90" cy="64" r="2.2" fill="#343434"/><circle cx="59" cy="74" r="3.2" fill="#343434"/>' +
    '<path d="M128 62 C134 76 140 88 148 99" stroke="#5E635D" stroke-width="5" fill="none" stroke-linecap="round"/>' +
    '{back}{chest}{neck}' +
    '<line x1="30" y1="232" x2="370" y2="232" stroke="#D9D9D4"/></svg>';
  var MARKS = {
    back: '<g stroke="#343434" stroke-width="1.2" fill="none"><line x1="148" y1="90" x2="324" y2="90" stroke-dasharray="4 3"/><line x1="148" y1="84" x2="148" y2="96"/><line x1="324" y1="84" x2="324" y2="96"/><line x1="236" y1="90" x2="236" y2="58"/></g>{n:236:48}',
    chest: '<g stroke="#343434" stroke-width="1.2" fill="none"><ellipse cx="160" cy="134" rx="10" ry="32" stroke-dasharray="4 3"/><line x1="160" y1="166" x2="130" y2="200"/></g>{n:124:208}',
    neck: '<g stroke="#343434" stroke-width="1.2" fill="none"><ellipse cx="137" cy="80" rx="8" ry="22" transform="rotate(-35 137 80)" stroke-dasharray="4 3"/><line x1="150" y1="64" x2="168" y2="40"/></g>{n:174:30}'
  };
  function numBadge(n, x, y) {
    return '<circle cx="' + x + '" cy="' + y + '" r="10" fill="#fff" stroke="#343434"/>' +
      '<text x="' + x + '" y="' + (y + 4) + '" text-anchor="middle" font-size="11" font-weight="600" fill="#343434" font-family="Montserrat, sans-serif">' + n + '</text>';
  }
  var KEY_ORDER = ['back', 'chest', 'neck'];
  var SVG_CACHE = {};
  var svgSeq = 0;
  function prepareSvg(txt) {
    var start = txt.indexOf('<svg');
    if (start < 0) return '';
    txt = txt.slice(start).replace(/<script[\s\S]*?<\/script>/gi, '');
    /* Illustrator-klasser (cls-1 …) gøres unikke, så de ikke rammer andre SVG'er på siden */
    var p = 'sg2i' + (++svgSeq) + '-';
    return txt.replace(/\bcls-/g, p);
  }
  function hydrateSvgs(scope) {
    scope.querySelectorAll('[data-sg2-svg]').forEach(function (el) {
      var url = el.getAttribute('data-sg2-svg');
      if (SVG_CACHE[url]) { if (!el.firstChild) el.innerHTML = SVG_CACHE[url]; return; }
      fetch(url).then(function (r) { return r.text(); }).then(function (txt) {
        SVG_CACHE[url] = prepareSvg(txt);
        scope.querySelectorAll('[data-sg2-svg="' + url + '"]').forEach(function (x) { x.innerHTML = SVG_CACHE[url]; });
      }).catch(function () { el.innerHTML = '<img src="' + esc(url) + '" alt="" width="2048" height="2290">'; });
    });
  }

  function chartPanelHTML(chart, t, recSize, label, illustration) {
    var keys = KEY_ORDER.filter(function (k) { return chart.measurements.some(function (m) { return m.key === k; }); });
    var html;
    /* Staeys egne illustrationer, én pr. kombination af mål (fx "back,chest", "chest,neck").
       Findes der ingen til kombinationen, bruges den tegnede hund. */
    var imgUrl = illustration && typeof illustration === 'object' ? illustration[keys.join(',')] : null;
    if (imgUrl) {
      /* SVG'en indsættes direkte i siden (ikke som <img>), så tallene kan bruge sidens Montserrat */
      html = '<div class="sg2-illu sg2-illu--img" data-sg2-svg="' + esc(imgUrl) + '">' + (SVG_CACHE[imgUrl] || '') + '</div>';
    } else {
      var svg = DOG_SVG;
      KEY_ORDER.forEach(function (k) {
        var i = keys.indexOf(k);
        var mark = i >= 0 ? MARKS[k].replace(/\{n:(\d+):(\d+)\}/, function (_, x, y) { return numBadge(i + 1, +x, +y); }) : '';
        svg = svg.replace('{' + k + '}', mark);
      });
      html = '<div class="sg2-illu">' + svg + '</div>';
    }
    if (keys.length) {
      html += '<p class="sg2-how__title">' + esc(t.how || '') + '</p><ol class="sg2-how">';
      keys.forEach(function (k, i) {
        html += '<li><span class="sg2-how__n">' + (i + 1) + '</span><div><strong>' + esc(label(k)) + '</strong><span>' + esc((t.how_to && t.how_to[k]) || '') + '</span></div></li>';
      });
      html += '</ol>';
    }
    var cols = chart.measurements;
    html += '<div class="sg2-table-wrap"><table class="sg2-table"><thead><tr><th>' + esc(t.size_col || 'Size') + '</th>';
    cols.forEach(function (m) { html += '<th>' + esc(label(m.key)) + ' (cm)</th>'; });
    html += '</tr></thead><tbody>';
    chart.sizes.forEach(function (s) {
      html += '<tr' + (s === recSize ? ' class="is-rec"' : '') + '><td>' + esc(s) + '</td>';
      cols.forEach(function (m) { var r = m.bySize[s]; html += '<td>' + (r ? (r.min + ' – ' + r.max) : '–') + '</td>'; });
      html += '</tr>';
    });
    html += '</tbody></table></div>';
    return html;
  }


  function initCalc(root) {
    if (root.__sg2) return; root.__sg2 = true;
    var cfgEl = root.querySelector('script[data-sg2-config]');
    if (!cfgEl) return;
    var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var t = cfg.t || {};
    var chart = parseMal(cfg.mal);
    if (!chart.measurements.length) return;
    var inputs = root.querySelectorAll('[data-sg2-input]');
    var out = root.querySelector('[data-sg2-result]');
    var chartPanel = root.querySelector('[data-sg2-panel="chart"]');
    var tabsEl = root.querySelector('[data-sg2-tabs]');
    var lastRec = null;
    if (tabsEl) {
      var tabs = (t.tabs || {});
      tabsEl.innerHTML = '<button type="button" role="tab" class="sg2-tab is-active" aria-selected="true" data-sg2-tab="find">' + esc(tabs.find || 'Find') + '</button>' +
        '<button type="button" role="tab" class="sg2-tab" aria-selected="false" data-sg2-tab="chart">' + esc(tabs.chart || 'Size chart') + '</button>';
      tabsEl.addEventListener('click', function (e) {
        var b = e.target.closest('[data-sg2-tab]'); if (!b) return;
        var name = b.getAttribute('data-sg2-tab');
        tabsEl.querySelectorAll('[data-sg2-tab]').forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
        root.querySelectorAll('[data-sg2-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-sg2-panel') !== name; });
      });
    }
    function renderChart(recSize) { if (chartPanel) { chartPanel.innerHTML = chartPanelHTML(chart, t, recSize, label, cfg.illustrations); hydrateSvgs(chartPanel); } }
    var viewIndex = null;
    var saved = loadSaved();
    var prefilled = false;

    inputs.forEach(function (inp) {
      var k = normKey(inp.getAttribute('data-sg2-input'));
      if (saved[k] != null && inp.value === '') { inp.value = saved[k]; prefilled = true; }
      inp.addEventListener('input', function () { viewIndex = null; prefilled = false; render(true); });
    });

    function readInput() {
      var o = {};
      inputs.forEach(function (inp) {
        var v = parseFloat(String(inp.value).replace(',', '.'));
        if (!isNaN(v) && v > 0) o[normKey(inp.getAttribute('data-sg2-input'))] = v;
      });
      return o;
    }

    function label(key) { return (t.labels && t.labels[key]) || key; }

    function selectSize(size) {
      var id = cfg.variantMap && cfg.variantMap[size];
      /* Luk slideren først, vælg så varianten */
      var drawer = root.closest('x-drawer');
      if (drawer && typeof drawer.hide === 'function') drawer.hide();
      setTimeout(function () {
        var el = id ? document.querySelector('variant-picker input[value="' + id + '"]') : null;
        if (el) { el.click(); return; }
        var labels = document.querySelectorAll('variant-picker .block-swatch');
        for (var i = 0; i < labels.length; i++) { if (labels[i].textContent.trim() === size) { labels[i].click(); break; } }
      }, 60);
    }

    function render(persist) {
      var input = readInput();
      if (persist) { var s = loadSaved(); Object.keys(input).forEach(function (k) { s[k] = input[k]; }); save(s); }
      var rec = recommend(chart, input, { tieBreak: cfg.tieBreak });
      renderChart(rec.size);
      if (rec.empty) { out.hidden = true; out.innerHTML = ''; return; }
      out.hidden = false;
      if (rec.size == null) {
        out.innerHTML = '<div class="sg2-card sg2-card--none"><p class="sg2-none">' + esc(t.no_size) + '</p></div>';
        return;
      }
      var idx = viewIndex != null ? viewIndex : rec.index;
      var cur = rec.perSize[idx];
      var isRec = idx === rec.index;
      var html = '<div class="sg2-card">';
      html += '<div class="sg2-head"><span class="sg2-eyebrow">' + esc(isRec ? t.recommend : t.viewing) + '</span>';
      html += '<span class="sg2-size">' + esc(cur.size) + '</span></div>';

      cur.fits.forEach(function (f) {
        var lvl = f.level === 'too_tight' ? t.levels.too_tight : t.levels[f.level];
        html += '<div class="sg2-fit sg2-fit--' + f.level + '">';
        html += '<div class="sg2-fit__top"><span class="sg2-fit__name">' + esc(label(f.key)) + ' · ' + f.value + ' cm</span><span class="sg2-fit__lvl">' + esc(lvl) + '</span></div>';
        html += '<div class="sg2-bar"><span class="sg2-bar__zone"></span><span class="sg2-bar__dot" style="left:' + (f.level === 'too_tight' ? 98 : markerPos(f)) + '%"></span></div>';
        html += '<div class="sg2-bar__ends"><span>' + esc(t.loose_end) + '</span><span>' + esc(f.min + '–' + f.max + ' cm') + '</span><span>' + esc(t.tight_end) + '</span></div>';
        html += '</div>';
      });

      cur.fits.forEach(function (f) {
        if (f.tooLoose) html += '<p class="sg2-warn">' + esc((t.warn && t.warn[f.key]) || fmt(t.warn_generic, { m: label(f.key) })) + '</p>';
        if (f.level === 'too_tight') html += '<p class="sg2-warn sg2-warn--tight">' + esc(fmt(t.warn_tight, { m: label(f.key) })) + '</p>';
      });
      if (rec.missing.length && isRec) {
        html += '<p class="sg2-hint">' + esc(fmt(t.hint_more, { m: rec.missing.map(label).join(' / ') })) + '</p>';
      }

      html += '<div class="sg2-pills" role="group" aria-label="' + esc(t.other_sizes) + '">';
      rec.perSize.forEach(function (p, i) {
        var cls = 'sg2-pill sg2-pill--' + p.status + (i === idx ? ' is-active' : '') + (i === rec.index ? ' is-rec' : '');
        html += '<button type="button" class="' + cls + '" data-sg2-view="' + i + '">' + esc(p.size) + '<i aria-hidden="true"></i></button>';
      });
      html += '</div>';

      if (cur.status !== 'no') {
        html += '<button type="button" class="sg2-cta" data-sg2-select="' + esc(cur.size) + '">' + esc(fmt(t.select, { size: cur.size })) + '</button>';
      }
      if (prefilled) html += '<p class="sg2-hint">' + esc(t.remembered) + '</p>';
      html += '</div>';
      out.innerHTML = html;
    }

    out.addEventListener('click', function (e) {
      var v = e.target.closest('[data-sg2-view]');
      if (v) { viewIndex = parseInt(v.getAttribute('data-sg2-view'), 10); render(false); return; }
      var s = e.target.closest('[data-sg2-select]');
      if (s) selectSize(s.getAttribute('data-sg2-select'));
    });

    render(false);
  }

  function initAll() { document.querySelectorAll('[data-sg2]').forEach(initCalc); }

  /* Åbn slideren. Temaet genrenderer variant-pickeren ved variantskift, så der kan ligge
     flere drawers med samme id — behold én og fjern resten. */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-sg2-open]');
    if (!opener) return;
    e.preventDefault();
    var all = document.querySelectorAll('x-drawer[data-sg2-drawer="' + opener.getAttribute('data-sg2-open') + '"]');
    if (!all.length) return;
    var drawer = all[all.length - 1];
    for (var i = 0; i < all.length - 1; i++) { if (all[i] !== drawer && !all[i].hasAttribute('open')) all[i].remove(); }
    initAll();
    if (typeof drawer.show === 'function') drawer.show(opener); else drawer.setAttribute('open', '');
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
  try { new MutationObserver(function () { initAll(); }).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
})(typeof window !== 'undefined' ? window : this);
